var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "builder-landing-container" }, [
    _c(
      "div",
      { staticClass: "video-container white", attrs: { id: "video-header" } },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "title-container" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "happybox-button green border",
              on: { click: _vm.changePage }
            },
            [_vm._v("Start customizing a box")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "how-to", attrs: { id: "howto" } }, [
      _c("div", { staticClass: "how-wrapper" }, [
        _c("p", { staticClass: "title" }, [_vm._v("How to Build a Gift Box")]),
        _vm._v(" "),
        _c("div", { staticClass: "steps-container" }, [
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "step third" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("video", {
              staticClass: "main-image",
              attrs: {
                autoplay: "autoplay",
                playsinline: "",
                muted: "",
                loop: "loop",
                alt: "gif",
                src:
                  "https://cdn.shopify.com/videos/c/o/v/473dce62fe9d49d4ade3b0136cf1b987.mp4"
              },
              domProps: { muted: true }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "happybox-button green border",
            on: { click: _vm.changePage }
          },
          [_vm._v("Start customizing a box")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "giftspiration" }, [
      _vm._m(5),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-container flicker-wrapper" },
        [
          _c(
            "Flicking",
            {
              ref: "flicking",
              staticClass: "flicking-goc-collection",
              attrs: {
                plugins: _vm.plugins1,
                options: {
                  align: "prev",
                  circular: true,
                  preventDefaultOnDrag: true,
                  preventClickOnDrag: true,
                  panelsPerView: _vm.panelsQty
                }
              }
            },
            [
              _c("div", { staticClass: "inspiration" }, [
                _c("img", {
                  staticClass: "main-image lazyload",
                  attrs: {
                    alt: "builder",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Giftspiration.png?v=1734968930",
                    width: "300",
                    height: "400"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inspiration" }, [
                _c("img", {
                  staticClass: "main-image lazyload",
                  attrs: {
                    alt: "builder",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3094-min.png?v=1733257449",
                    width: "300",
                    height: "400"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inspiration" }, [
                _c("img", {
                  staticClass: "main-image lazyload",
                  attrs: {
                    alt: "builder",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3093-min.png?v=1733257449",
                    width: "300",
                    height: "400"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inspiration" }, [
                _c("img", {
                  staticClass: "main-image lazyload",
                  attrs: {
                    alt: "builder",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3098-min.png?v=1733257448",
                    width: "300",
                    height: "400"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inspiration" }, [
                _c("img", {
                  staticClass: "main-image lazyload",
                  attrs: {
                    alt: "builder",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3097-min.png?v=1733257448",
                    width: "300",
                    height: "400"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inspiration" }, [
                _c("img", {
                  staticClass: "main-image lazyload",
                  attrs: {
                    alt: "builder",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/Mask_Group_3092-min.png?v=1733257448",
                    width: "300",
                    height: "400"
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c("img", {
            staticClass: "arrow-left",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546"
            },
            on: {
              click: function($event) {
                return _vm.$refs.flicking.prev()
              }
            }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "arrow-right",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546"
            },
            on: {
              click: function($event) {
                return _vm.$refs.flicking.next()
              }
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("div", { staticClass: "testimonials" }, [
      _vm._m(7),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "testimonials-wrapper" },
        [
          _c(
            "Flicking",
            {
              ref: "testimonial",
              staticClass: "flicking-goc-collection",
              attrs: {
                plugins: _vm.plugins2,
                options: {
                  align: "prev",
                  circular: true,
                  preventDefaultOnDrag: true,
                  preventClickOnDrag: true,
                  panelsPerView: _vm.testimonialsPanels
                }
              }
            },
            [
              _c("div", { staticClass: "testimonial" }, [
                _c("div", [
                  _c("img", {
                    staticClass: "logo big",
                    attrs: {
                      width: "121",
                      height: "50",
                      loading: "lazy",
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/logo1.svg?v=1675714911",
                      alt: "Pfizer Logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "“I can’t even begin to tell you how delighted I am! The package and the gifts are terrific. Please thank your wonderful team on our behalf!”"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("- Ron K"), _c("br"), _vm._v("Pfizer")])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "stars",
                  attrs: {
                    width: "100",
                    height: "17",
                    loading: "lazy",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/stars_b69c938c-d760-480a-89ca-87c58943361a.svg?v=1697040058",
                    alt: "5 Stars"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "testimonial" }, [
                _c("div", [
                  _c("img", {
                    staticClass: "logo big",
                    attrs: {
                      width: "121",
                      height: "50",
                      loading: "lazy",
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/logo2.svg?v=1675714911",
                      alt: "The Agency Logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "“From gift box curation to shipping, the Happy Box team is truly dedicated, creative & helpful!”"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("- The Whitman Team"),
                    _c("br"),
                    _vm._v("The Agency")
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "stars lazyload",
                  attrs: {
                    width: "100",
                    height: "17",
                    loading: "lazy",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/stars_b69c938c-d760-480a-89ca-87c58943361a.svg?v=1697040058",
                    alt: "5 Stars"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "testimonial" }, [
                _c("div", [
                  _c("img", {
                    staticClass: "logo lazyload",
                    attrs: {
                      width: "121",
                      height: "50",
                      loading: "lazy",
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/logo3.svg?v=1675714911",
                      alt: "Rocket Insights Logo"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "“Happy Box helped us problem solve gifting our new remote hires!”"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("- Imogene, Majordomo"),
                    _c("br"),
                    _vm._v("Rocket Insights")
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "stars lazyload",
                  attrs: {
                    width: "100",
                    height: "17",
                    loading: "lazy",
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/stars_b69c938c-d760-480a-89ca-87c58943361a.svg?v=1697040058",
                    alt: "5 Stars"
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", [
      _c("source", {
        attrs: {
          media: "(max-width: 767px)",
          srcset:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/builder_mobile.png?v=1747057257"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "lazyload main-image",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/builder_1.png?v=1748623835",
          alt: "builder"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("Build the "),
      _c("br"),
      _vm._v("perfect gift")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step" }, [
      _c("div", { staticClass: "n-container" }, [
        _c("img", {
          staticClass: "number",
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/1_2c66e3ab-32f1-471b-8cec-ab39c01bca8e.svg?v=1732290520",
            alt: "step 1",
            width: "30",
            height: "30"
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "extra" }, [_vm._v("Select your gifts")])
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "main-image",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/step1_29403a40-b825-4dbb-b32c-e670a423650c.png?v=1743684012"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step second" }, [
      _c("div", { staticClass: "n-container" }, [
        _c("img", {
          staticClass: "number",
          attrs: {
            src:
              "https://cdn.shopify.com/s/files/1/1363/8433/files/2_80154837-6262-4262-a586-48750a4e452b.svg?v=1732290520",
            alt: "step 2",
            width: "30",
            height: "30"
          }
        }),
        _vm._v(" "),
        _c("p", [
          _vm._v("Pick your packaging & "),
          _c("br"),
          _vm._v(
            "\n                            we’ll handwrite your card\n                        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "main-image",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/step2_ab03ddbb-3ae3-4664-8d4e-eee6c5197b81.png?v=1743683379"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "n-container" }, [
      _c("img", {
        staticClass: "number",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/3_e08da053-2b0e-41bc-afda-594d7cff9155.svg?v=1732290519",
          alt: "step 3",
          width: "30",
          height: "30"
        }
      }),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n                            Sit back & "),
        _c("br"),
        _vm._v(
          "\n                            take all the credit\n                        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container" }, [
      _c("p", { staticClass: "main-title" }, [_vm._v("Builder Giftspiration")]),
      _vm._v(" "),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v("See what others have sent")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "happy-clients" }, [
      _c("div", { staticClass: "ticker-wrap" }, [
        _c("div", { staticClass: "ticker" }, [
          _c("div", { staticClass: "slide" }, [
            _c("img", {
              attrs: {
                width: "1678",
                height: "67",
                loading: "lazy",
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/logos_d6cd25b6-2f6f-422d-b06e-bee48844c2cb.svg?v=1675281939"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "slide" }, [
            _c("img", {
              attrs: {
                width: "1678",
                height: "67",
                loading: "lazy",
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/logos_d6cd25b6-2f6f-422d-b06e-bee48844c2cb.svg?v=1675281939"
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "main-title" }, [
      _c("span", [_vm._v("Happy")]),
      _vm._v(" Clients")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }